export const COMPANY = {
  name: "Rossi Energia",
  legal: "Rossi Energia SRL",
  email: "info@rossienergiasrl.it",
  address: "Via Magro 47, 45021 Badia Polesine (RO), Italia",
  addressShort: "Via Magro 47, Badia Polesine (RO)",
  piva: "01667300295",
  orari: "Tutti i giorni · 9:00–12:30 / 15:00–18:00",
  phone: "+39 0425 096004",
  phoneTel: "tel:+390425096004",
  whatsapp:
    "https://wa.me/393802056905?text=Ciao%2C%20vorrei%20far%20controllare%20la%20mia%20bolletta.",
  logo: "/logo.png",
};

export const NAV = [
  { label: "Servizi", href: "#servizi" },
  { label: "Perché noi", href: "#perche" },
  { label: "Come funziona", href: "#come-funziona" },
  { label: "FAQ", href: "#faq" },
];
